"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicPage = void 0;
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var React = require("react");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var Message_1 = require("@/pages/common/components/Message");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var Pages_1 = require("@/rendering/common/Pages");
var Login_1 = require("@/pages/common/components/Login");
var CallOrEmail_1 = require("@/pages/common/components/CallOrEmail");
var Loading_1 = require("@/pages/common/components/Loading");
var MegaMenuSide_1 = require("@/pages/common/components/MegaMenuSide");
var mapStateToProps = function (state, ownProps) { return (__assign(__assign({}, state), { children: ownProps.children, userFrom: state.user.from, user: state.user, stickyMenu: ownProps.stickyMenu })); };
var mapDispatchToProps = function () { return ({}); };
exports.publicPage = function (props) {
    var appClasses = classnames_1.default({ 'c-calloremail--active': props.layout.callOrEmailActive });
    return (React.createElement("div", { id: "publicpage", className: appClasses },
        React.createElement(Loading_1.default, null),
        React.createElement(Bigpopup_1.default, null),
        React.createElement(Message_1.default, null),
        props.stickyMenu ? (React.createElement("div", { className: "c-navbar--border" },
            React.createElement(MegaMenu_1.default, { nobottom: true }))) : (React.createElement("div", { className: "l-arch__topmenu" },
            React.createElement(MegaMenu_1.default, { nobottom: true }))),
        React.createElement(MegaMenuSide_1.default, null),
        props.children,
        React.createElement(Megafoot_1.default, null),
        props.page === Pages_1.Pages.ACCOUNT_LOGIN ? '' : (React.createElement(Login_1.default, null)),
        React.createElement(CallOrEmail_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.publicPage);
